import styled from 'styled-components/native'
import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'

export const ContentCardContainer = styled(DialogueTouchableOpacity)<{ width: number }>`
  margin: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  width: ${({ width }) => width};
  ${({ theme }) => theme.shadows.soft}
`

export const ContentContainer = styled.View<{ maxWidth: number }>`
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  flex-direction: column;
  justify-content: space-between;
  max-width: ${({ maxWidth }) => maxWidth};
`

export const Content = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  gap: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

export const StyledTag = styled(Typography).attrs(() => ({
  variant: 'bodySmall',
}))`
  text-transform: capitalize;
  padding-left: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const ImageContainer = styled.View`
  position: relative;
  overflow: hidden;
  border-top-left-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  border-top-right-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const Image = styled.Image`
  aspect-ratio: 2;
  width: '100%';
`
